const enum Direction {
    ASC,
    DESC,
}

export default Direction;
